<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    openPopup() {
      this.togglePopup('order-call-with-message');
      this.addTitlePopup('<span>Подать</span> заявку на выкуп');
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row 2xl:mt-40 2xl:mb-20">
        <div class="relative hidden xl:block w-full lg:w-1/2">
          <div class="static lg:absolute top-0 right-0 w-full lg:w-[calc(100%+(100vw-990px)/2)] xl:w-[calc(100%+(100vw-1140px)/2)] 2xl:w-[calc(100%+(100vw-1220px)/2)] h-full flex items-center justify-center">
            <img
              class="w-full sm:w-10/12 lg:w-full max-w-[980px] h-auto"
              src="/public/images/pages/vikup/image-36.png"
              alt=""
            >
          </div>
        </div>

        <div class="w-full xl:w-[47%] ml-auto">
          <h2 class="title-h2 mb-6">Почему вам понравится работать с&nbsp;нами?</h2>

          <div class="grid grid-cols-2 gap-x-5 gap-y-5 mb-5">
            <div class="bg-white p-4 rounded-big-brand">
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#work1"></use>
              </svg>
              <p class="text-sm text-gray-600">У нас доступна услуга – мобильный выкуп! Если вам неудобно ехать, то&nbsp;мы сами приедем к&nbsp;вам.</p>
            </div>

            <div class="bg-white p-4 rounded-big-brand">
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#work2"></use>
              </svg>
              <p class="text-sm text-gray-600">В наших дилерских центрах вы&nbsp;также можете воспользоваться услугами комиссионной продажи и&nbsp;Trade in.</p>
            </div>

            <div class="col-start-1 col-end-3 bg-white p-4 rounded-big-brand">
              <svg class="w-[46px] min-w-[46px] h-[46px] mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#work3"></use>
              </svg>
              <p class="text-sm text-gray-600">Более 30 лет на&nbsp;рынке, высокий уровень экспертизы, высококвалифицированные менеджеры. Мы&nbsp;гарантируем качество сделки!</p>
            </div>
          </div>

          <div
            class="button button_green button_big w-full"
            @click="openPopup"
          >Подать заявку на выкуп</div>
        </div>
      </div>
    </div>
  </div>
</template>
